/**
 * Wave X.B · Frontend Sentry init
 * Loaded by index.js BEFORE React render. Graceful no-op if DSN missing.
 */
export async function initFrontendSentry() {
    // Accept both the wave_x_b-scoped name AND the canonical name populated
    // via the secrets card. First-wins.
    const dsn = (
        process.env.REACT_APP_SENTRY_DSN_FRONTEND
        || process.env.REACT_APP_SENTRY_DSN
        || ""
    ).trim();
    if (!dsn) {
        // eslint-disable-next-line no-console
        console.info("[wave_x_b.sentry] disabled · neither REACT_APP_SENTRY_DSN_FRONTEND nor REACT_APP_SENTRY_DSN set");
        return false;
    }
    try {
        const Sentry = await import("@sentry/react");
        const integrations = [Sentry.browserTracingIntegration()];
        if (Sentry.replayIntegration) {
            integrations.push(
                Sentry.replayIntegration({
                    maskAllText: true,
                    blockAllMedia: true,
                }),
            );
        }
        Sentry.init({
            dsn,
            environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "preview",
            release: process.env.REACT_APP_SENTRY_RELEASE,
            tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || 0.1),
            replaysSessionSampleRate: 0,
            replaysOnErrorSampleRate: 0.1,
            sendDefaultPii: false,
            integrations,
            beforeSend(event) {
                try {
                    if (event?.request?.url && /\/api\/health/.test(event.request.url)) return null;
                    if (event?.request?.headers) {
                        for (const h of ["authorization", "Authorization", "cookie", "Cookie", "set-cookie"]) {
                            if (event.request.headers[h]) event.request.headers[h] = "[Filtered]";
                        }
                    }
                    // Drop 401/403/404 as not-errors
                    const msg = String(event?.message || "");
                    if (/\b(401|403|404)\b/.test(msg)) return null;
                    return event;
                } catch {
                    return null;
                }
            },
        });
        Sentry.setTag("service", "spa");
        Sentry.setTag("stack", "react-cra");
        return true;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn("[wave_x_b.sentry] init failed", e?.message || e);
        return false;
    }
}
